import { FC } from "react";

import { Json } from "@src/utils/json";

import { SHOW_JSON_CONFIGS } from "../appConfig";

interface DebugProps {
  data: object;
  collapsed?: boolean;
  name?: string;
}
export const Debug: FC<DebugProps> = ({ data, collapsed, name }) => {
  if (SHOW_JSON_CONFIGS && typeof data === "object") {
    return <Json data={data} name={name} />;
  }
  return null;
};
